import { render, staticRenderFns } from "./MessagesOther.vue?vue&type=template&id=6f764b18&"
import script from "./MessagesOther.vue?vue&type=script&lang=js&"
export * from "./MessagesOther.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports